import { Component, HostListener, OnInit } from '@angular/core';
import {
  AnnouncementService,
  MarketplaceItemV2,
  MarketplaceV2Service,
  MarketplaceV2Query,
  MixedLoyaltyItem,
  MixedLoyaltyQuery,
  ProcessProviderId,
  REWARD_STATUS,
  PopulationQuery,
} from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { firstValueFrom, map, Observable, tap } from 'rxjs';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';
import { Populations } from 'src/app/shared/utilities/populations';

enum RewardWidth {
  Destop = 302,
  Tablet = 194,
  Mobile = 165,
}
@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  campaignOffersList = [];
  screenType = ScreenType;
  population = Populations;
  mixedLoyaltyItems$: Observable<MixedLoyaltyItem[] | null>;
  marketplaceItems$: Observable<MarketplaceItemV2[]>;
  rewardMarketplaceItems: Observable<MarketplaceItemV2[]>;
  rewardsWidth: number | string;
  isKid: boolean;
  customOptions: OwlOptions = {
    autoHeight: true,
    autoWidth: true,
    margin: OwlCarouselSettings.Margin,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: { items: 2 },
      740: { items: 2 },
      900: { items: 3 },
    },
    dots: true,
  };

  constructor(
    private announcementService: AnnouncementService,
    private populationQuery: PopulationQuery,
    private marketplaceQuery: MarketplaceV2Query,
    private marketplaceService: MarketplaceV2Service,
    private mixedLoyaltyService: MixedLoyaltyQuery
  ) { }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.setRewardsWidth(event?.target.screen.width);
  }

  ngOnInit() {
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
    firstValueFrom(this.marketplaceService.fetchMarketplaceItems());
    firstValueFrom(this.announcementService.fetchAnnouncements());
    this.fetchFavouriteEventItems();
    this.fetchFavouriteMarketplaceItems();
    this.fetchExperienesAndRewardsItems();
    this.setRewardsWidth(window.screen.width);
  }

  onCampaignOfferListChange(e: any) {
    this.campaignOffersList = e?.CampaignsAndEntitlements || [];
  }

  fetchExperienesAndRewardsItems() {
    this.mixedLoyaltyItems$ = this.mixedLoyaltyService
      .selectFavouriteMixedLoyaltyItems()
      .pipe(
        map(items =>
          items
            ?.filter(item => {
              if (this.isKid) {
                return item.type === 'marketplace'
              } else {
                return item.type === 'marketplace' || item.type === 'lotto'
              }
            })
        ),
        tap(items => console.log(items))
      );
  }

  fetchFavouriteEventItems() {
    let ProcessProviderId: ProcessProviderId[] = [3];
    this.marketplaceItems$ = this.marketplaceQuery.selectMarketplaceItemsOfType(ProcessProviderId).pipe(
      map((items) => {
        return items?.filter((item) =>
          item.Status !== REWARD_STATUS.SoldOut
        );
      })
    );
  }

  fetchFavouriteMarketplaceItems() {
    let ProcessProviderId: ProcessProviderId[] = [0, 1, 2];
    this.rewardMarketplaceItems = this.marketplaceQuery
      .selectMarketplaceItemsOfType(ProcessProviderId).pipe(
        map((items) => {
          return items?.filter((item) => item.Status === REWARD_STATUS.Favourite);
        })
      );
  }

  setRewardsWidth(screenSize: number) {
    if (screenSize >= 992) this.rewardsWidth = RewardWidth.Destop;
    if (screenSize < 992 && screenSize >= 425) this.rewardsWidth = RewardWidth.Tablet;
    if (screenSize < 425) this.rewardsWidth = RewardWidth.Mobile;
  }
}
